import type {FC} from 'react';
import type {Recruitment} from '../../../../core/entities/recruitment/schema';
import {CardForPc} from '../../../recruitingInfo/components/Container/Presenter/CardForPc';
import {CardForSp} from '../../../recruitingInfo/components/Container/Presenter/CardForSp';

type Props = {
  list: Recruitment[];
};
export const RecruitingInfoList: FC<Props> = ({list}) => {
  return (
    <div className="flex flex-col gap-[16px] mx-16 pc:mx-0">
      <div className="w-full bg-white shadow rounded-[12px] flex justify-between items-center p-16">
        <span className="font-bold text-[18px] leading-[27px] pc:text-[24px] pc:leading-[26.4px]">
          募集情報
        </span>
      </div>

      <div className="hidden pc:grid grid-cols-2 gap-24">
        {list.map((info) => (
          <CardForPc recruitment={info} key={info.id} />
        ))}
      </div>
      <div className="flex pc:hidden flex-col gap-8">
        {list.map((info) => (
          <CardForSp
            recruitment={info}
            key={info.id}
            className="rounded-[24px] shadow"
          />
        ))}
      </div>
    </div>
  );
};
